<section class="filters">
  <mat-form-field>
    <mat-label>{{ "posts.filters.name.label" | translate }}</mat-label>
    <input #nameInput
      matInput
      [placeholder]="'posts.filters.name.placeholder' | translate"
      (input)="filterByName()"
    />
  </mat-form-field>
  <mat-form-field *ngIf="user">
    <mat-label>{{ "posts.filters.status.label" | translate }}</mat-label>
    <mat-select #statusSelect (selectionChange)="submitFilter()" value="">
      <mat-option value="">{{ "posts.filters.status.options.any" | translate }}</mat-option>
      <mat-option value="PUBLISHED">{{ "posts.filters.status.options.published" | translate }}</mat-option>
      <mat-option value="WAITING_VALIDATION">{{ "posts.filters.status.options.waiting_validation" | translate }}</mat-option>
      <mat-option value="WAITING_PAYMENT">{{ "posts.filters.status.options.waiting_payment" | translate }}</mat-option>
      <mat-option value="DRAFT">{{ "posts.filters.status.options.draft" | translate }}</mat-option>
      <mat-option value="EXPIRED">{{ "posts.filters.status.options.expired" | translate }}</mat-option>
      <mat-option value="ARCHIVED">{{ "posts.filters.status.options.archived" | translate }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field *ngIf="user">
    <mat-label>{{ "posts.actions.create.fields.category.label" | translate }}</mat-label>
    <mat-select #categorySelect (selectionChange)="submitFilter()" value="">
      <mat-option value="">{{ "posts.actions.create.fields.category.options.any" | translate }}</mat-option>
      <mat-option value="yearling">{{ "posts.actions.create.fields.category.options.yearling" | translate }}</mat-option>
      <mat-option value="training">{{ "posts.actions.create.fields.category.options.training" | translate }}</mat-option>
      <mat-option value="two_years">{{ "posts.actions.create.fields.category.options.two_years" | translate }}</mat-option>
      <mat-option value="out_training">{{ "posts.actions.create.fields.category.options.out_training" | translate }}</mat-option>
      <mat-option value="broodmare">{{ "posts.actions.create.fields.category.options.broodmare" | translate }}</mat-option>
      <mat-option value="stallion">{{ "posts.actions.create.fields.category.options.stallion" | translate }}</mat-option>
    </mat-select>

  </mat-form-field>
  <mat-form-field>
    <mat-label>{{ "posts.filters.author.label" | translate }}</mat-label>
    <input #authorInput
      type="text"
      matInput
      [value]="filtered_author"
      [formControl]="filterByAuthorControl"
      [matAutocomplete]="auto"
    />
    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
      <mat-option value="any">
        {{ "posts.filters.author.options.any" | translate }}
      </mat-option>
      <mat-option value="me">
        {{ "posts.filters.author.options.me" | translate }}
      </mat-option>
      <mat-option
        *ngFor="let option of filteredAuthors | async"
        [value]="option">
        {{ option }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <button class="toggle-posts-layout" (click)="togglePostsLayout()">
    <mat-icon *ngIf="currentPostsLayout" aria-hidden="false" aria-label="open filter" svgIcon="layout-list"></mat-icon>
    <mat-icon *ngIf="!currentPostsLayout" aria-hidden="false" aria-label="open filter" svgIcon="layout-grid"></mat-icon>
    <span class="toggle-posts-layout-label">affichage des résultats</span>
  </button>
</section>
